import { Button, Modal,message,Row,Col, Spin} from 'antd';
import isEmpty from 'lodash/isEmpty'
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import toString from 'lodash/toString'
import forEach from 'lodash/forEach'
import { WeaErrorPage, WeaTools,WeaTableEdit,WeaSearchGroup,WeaRightMenu, WeaFormItem,WeaTab} from 'ecCom'
import {WeaSwitch} from 'comsMobx';
import { inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import {i18n} from '../../public/i18n';
const toJS = mobx.toJS;

@inject('hrmWork')
@inject('hrmCard')
@observer
class Work extends React.Component {
  constructor(props) {
    super(props);
    const funcs = ['tableEditChange', 'editCard','backCard','saveEditCard', 'onTabChange'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }
  componentDidMount(){
    const {hrmCard} = this.props;
    hrmCard.setTopButtons(this.getTopButtons.bind(this));
    hrmCard.setTopRightMenus(this.getRightMenu.bind(this));
    hrmCard.setTopShowDropIcon(true);
    this.init();
  }

  init() {
    const {hrmWork} = this.props;
    const hrmId = this.props.params.hrmId || '';
    hrmWork.init();
    hrmWork.hrmId=hrmId;
    hrmWork.getData();
  }
  getTabChildren(){
    const {hrmWork} = this.props;
    let {tableInfo, isEditor, tabkey} = hrmWork;
    let tabChildren = [];
    tableInfo = toJS(tableInfo);
    tableInfo && tableInfo.map((t,i)=>{
        if(tabkey==i){
            tabChildren.push(
                <WeaTableEdit
                    ref={(ref)=>hrmWork.setWorkEditTables(ref)}
                    showTitle={isEditor}
                    // title={'列表信息'}
                    addFirstRow={isEditor}
                    columns={t.tabinfo.columns}
                    datas={t.tabinfo.datas}
                    onChange={this.tableEditChange}
                    viewAttr={isEditor?2: 1}
                    getRowSelection={isEditor? null: ()=>null}
                />
            );
        }
    })
    return tabChildren;
  }
  getSearchs(){
    const {hrmWork} = this.props;
    let {form, conditions, isEditor} = hrmWork;
    const {isFormInit} = form;
    let group = [];
    let tipPosition = 'bottom';
    conditions = toJS(conditions);
    window.e9HideFormFieldKeys = [];
    isFormInit && conditions.forEach(c =>{
        let items = [];
        c.items.forEach( field => {
          if(c.hide || (!isEmpty(field.otherParams) && field.otherParams.hide)){
            window.e9HideFormFieldKeys.push(field.domkey[0]);
          }else{
            items.push({
                com:(<WeaFormItem
                    underline={!isEditor}
                    label={`${field.label}`}
                    error={form.getError(field)}
                    tipPosition={tipPosition}
                    labelCol={{span: `${window.HrmLabelCol}`}}
                    wrapperCol={{span: `${window.HrmWrapperCol}`}}>
                      <WeaSwitch fieldConfig={field} form={form} onChange={(v)=> {
                        if (field.domkey[0]=='companystartdate' || field.domkey[0]=='workstartdate') {
                          let value = 0.00;
                          let obj = {};
                          let domKey = '';
  
                          if (field.domkey[0]=='companystartdate') {
                            domKey = 'companyworkyear';
                          }else if(field.domkey[0]=='workstartdate'){
                            domKey = 'workyear';
                          }
                          value = hrmWork.calYear(v[field.domkey[0]].value);
                          obj[domKey]={value};
                          form.updateFields(obj);
                        }
                      }}/>
                    </WeaFormItem>),
                colSpan: 1
              });
          }
        });
        group.push(<WeaSearchGroup className={`${isEditor?'hrm-center':''}`} hide={c.hide} 
          needTigger={true} title={c.title} showGroup={c.defaultshow} items={items} col={window.HrmGroupCol}/>)
    });
    return group;
  }
  tableEditChange(data){
    const {hrmWork} = this.props;
    let {tabkey = '0', tableInfo} = hrmWork;
    tableInfo = toJS(tableInfo);
    let d = cloneDeep(tableInfo);
    d[Number(tabkey)].tabinfo.datas = data;
    hrmWork.updateTableInfo(d);
  }
  onTabChange(key) {
    const {hrmWork} = this.props;
    hrmWork.changeTab(key);
  }
  getRightMenu(){
    const {hrmWork, hrmCard} = this.props;
    const {isEditor, buttons,hrmId} = hrmWork;
    let arr = [];
    if(buttons.hasEdit){
        if (isEditor){
            arr = [{
                icon: <i className='icon-coms-common'/>,
                content: i18n.button.save(),
                key: 'save',
                onClick: key =>{
                  this.saveEditCard();
                }
              }, {
                icon: <i className='icon-coms-go-back'/>,
                content: i18n.button.back(),
                key: 'back',
                onClick: key =>{
                  this.backCard();
                }
              }]
        } else {
            arr = [{
                    icon: <i className='icon-coms-edit'/>,
                    content:i18n.button.modify(),
                    key: 'editCard',
                    onClick: key =>{
                        this.editCard();
                      }
                }
            ]

            arr.push(
              {
                icon: <i className='icon-coms-Print-log'/>,
                content:i18n.button.log(),
                key: 'showLog',
                onClick: key =>{
                  window.setLogViewProps({logSmallType:i18n.smallType.HRM_RSOURCE_CARD_WORK,targetId:hrmId});
                }
              }
            )
        }
    }
    return arr;
  }
  
  getTopButtons() {
    const {hrmWork} = this.props;
    const {isEditor, buttons} = hrmWork;
    const save = <Button type="primary" onClick={this.saveEditCard} >{i18n.button.save()}</Button>;
    const back = <Button type="primary" onClick={this.backCard} >{i18n.button.back()}</Button>;
    const edit = <Button type="primary" onClick={this.editCard} >{i18n.button.modify()}</Button>;
    const btns = [];
    if (isEditor) {
      if (buttons.hasSave) {
        btns.push(save);
        btns.push(back);
      }
    } else {
      if (buttons.hasEdit) {
        btns.push(edit);
      }
    }
    return btns;
  }
  editCard(){
    const {hrmWork} = this.props;
    hrmWork.edit();
  }
  saveEditCard(){
    const {hrmWork} = this.props;
    hrmWork.save();
  }
  backCard(){
    this.init();
  }
  render() {
    const {hrmWork} = this.props;
    const {loading, tabkey, tabInfo, date} = hrmWork;
    return  (
        <div className='hrm-my-cardInfo' style={{height:'100%', position: 'relative'}}>
            <Spin spinning={loading}>
                <WeaRightMenu
                    datas={this.getRightMenu()}
                >
                    {this.getSearchs()}
                    {
                      !isEmpty(tabInfo) && <div className='hrm-my-cardInfo_detial_tabs'>
                      <WeaTab
                          type='card'
                          keyParam='key'
                          datas={toJS(tabInfo)}
                          selectedKey={tabkey}
                          onChange={ v => {
                              hrmWork.updateTabkey(v);
                          }}
                      />
                      {this.getTabChildren()}
                  </div>
                    }

                </WeaRightMenu>
            </Spin>
        </div>
    )
  }
}

export default Work;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/card/Work.js